import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { ICountry } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'countrys'

// const getAll = (axios: IFactoryFunctionRequest<Array<ICountry>, undefined>) => () => {
//   return axios({
//     method: EMethod.get,
//     url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
//   })
// }

const getOne = (axios: IFactoryFunctionRequest<ICountry | undefined, undefined>) => (_id: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/paginated`,
    query: {
      ids: [_id],
      page: 0,
      limit: 1,
    },
    afterReceivingHook: (response) => response?.docs?.[0],
  })
}


const getAllPaginated = (axios: IFactoryFunctionRequest<Array<ICountry>, any>) => ( {
  page = 0,
  limit = 24,
  searchString,
  scope,
  ids = []
}:
{
  page?: number
  searchString?: string
  limit?: number,
  scope?: string,
  ids?: string[],
}) => {
  const query = { page, searchString, limit, scope, ids }
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/paginated`,
    query,
  })
}


export default (axios: AxiosInstance) => ({
  // getAll : getAll(useAxios(axios)),
  getOne: getOne(useAxios(axios)),
  getAllPaginated: getAllPaginated(useAxios(axios)),
})
